export const AuthProvider = ({children}) => {
  return <Provider>{children}</Provider>
}

const Provider = ({children}) => {
  return children
}
